const searchIntents = [
  {
    query: "Vigorbuy Spreadsheet Tutorial",
    description: "Learn step-by-step how to use Vigorbuy Spreadsheet effectively for your daily tasks.",
    icon: "ri-graduation-cap-line",
  },
  {
    query: "Vigorbuy Spreadsheet Templates",
    description: "Find the best ready-to-use templates for business, inventory, and personal organization.",
    icon: "ri-file-copy-line",
  },
  {
    query: "Vigorbuy Spreadsheet Review",
    description: "Read honest reviews and real user experiences with Vigorbuy Spreadsheet features.",
    icon: "ri-star-line",
  },
  {
    query: "Vigorbuy Spreadsheet Safety",
    description: "Understand security measures and best practices for safe spreadsheet usage.",
    icon: "ri-shield-check-line",
  },
  {
    query: "Vigorbuy Spreadsheet Alternatives",
    description: "Compare Vigorbuy Spreadsheet with other popular tools to find your perfect fit.",
    icon: "ri-scales-3-line",
  },
  {
    query: "Vigorbuy Spreadsheet Download",
    description: "Get access to downloadable templates, resources, and spreadsheet guides.",
    icon: "ri-download-2-line",
  },
];

export default function SearchIntentSection() {
  return (
    <section id="guides" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Why People Search Vigorbuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Discover the most common reasons users explore Vigorbuy Spreadsheet and how it helps them achieve more.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {searchIntents.map((item) => (
            <div
              key={item.query}
              className="flex items-start gap-4 p-5 bg-background-50 border border-background-200/60 rounded-lg hover:border-secondary-300/60 transition-all duration-200"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="text-sm font-label font-semibold text-foreground-900 mb-1">
                  {item.query}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}